import {Component, inject, OnInit} from '@angular/core';
import {IndexIoService} from '../../services/index-io.service';
import {NgForOf} from '@angular/common';
import {DocumentsDTO} from '../../models/dto/document-dto';

@Component({
  selector: 'bnpp-indx-contact',
  imports: [
    NgForOf
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
  standalone: true,
})
export class ContactComponent implements OnInit {

  private indexInfoService = inject(IndexIoService);
  public deployUrlHost = this.indexInfoService.getDeployUrlHost();
  documentsForComplaintInfo = this.indexInfoService.documentsForComplaintsInfo;


  ngOnInit(): void {
    this.indexInfoService.getDocumentsForComplaints();
  }

  onDownloadDocument(item: DocumentsDTO) {
    this.indexInfoService.downloadDocument("Document",item.Path,item.Title,item.FileExtension,item.S3Key).subscribe();
  }

}
